import { Link } from "react-router-dom";

const AdminHeader = () => {
  return (
    <nav className="bg-neutral-primary w-full z-20 top-0 start-0 border-b border-default absolute">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <div className="hidden w-full md:block md:w-auto" id="navbar-default">
          <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-default rounded-base bg-neutral-secondary-soft md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-neutral-primary">
            <li>
              <Link
                className="block py-2 px-3 bg-brand rounded md:bg-transparent md:text-fg-brand md:p-0"
                aria-current="page"
                to="/admin-panel"
              >
                Главная
              </Link>
            </li>
            <li>
              <Link
                className="block py-2 px-3 bg-brand rounded md:bg-transparent md:text-fg-brand md:p-0"
                aria-current="page"
                to="/operator"
              >
                Операторы
              </Link>
            </li>
            <li>
              <Link
                className="block py-2 px-3 bg-brand rounded md:bg-transparent md:text-fg-brand md:p-0"
                aria-current="page"
                to="/organization"
              >
                Организации
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AdminHeader;
